/**
 * Dish photos come from the POS at full size (900×900, 100–190 KB each). A
 * grid tile draws one at about 160 px, so it asks for the server's small copy
 * instead — same name under /uploads/thumbs/, a 320 px WebP of 10–20 KB.
 */
export function thumbUrl(imageUrl) {
  if (!imageUrl || !imageUrl.startsWith('/uploads/')) return imageUrl;
  return imageUrl.replace(/^\/uploads\//, '/uploads/thumbs/');
}
